import CIcon from '@coreui/icons-react';
import { CTooltip } from '@coreui/react';
import TextConstants from 'src/common/helpers/TextConstants';

const RECEIVER_ERROR_CODES = [1, 2, 3, 4, 5];
export const POWER_ERROR_CODES = [1, 2];

const mapErrorCodeToText = (errCodes, powerError) => {
  const errors = [];

  if (RECEIVER_ERROR_CODES.some((item) => errCodes.includes(item))) {
    errors.push(TextConstants.ReceiversManagement.ErrorEquipment);
  }

  if (POWER_ERROR_CODES.includes(powerError)) {
    errors.push(TextConstants.ReceiversManagement.ErrorPowerSupply);
  }

  return errors.join('/');
};

export const ReceiverErrorTransformer = (rer, prs) => {
  const errCodes = !isNaN(rer) ? rer.toString().split('').map(Number) : [];
  const powerSuplyStatus = parseInt(prs);

  if (
    !RECEIVER_ERROR_CODES.some((item) => errCodes.includes(item)) &&
    !POWER_ERROR_CODES.includes(powerSuplyStatus)
  ) {
    return '';
  }

  const errDisplayValue = mapErrorCodeToText(errCodes, powerSuplyStatus);
  return errDisplayValue;
};

const getTooltipMessage = (errCodes, powerError) => {
  const messages = [];

  errCodes.forEach((errCode) => {
    if (RECEIVER_ERROR_CODES.includes(errCode)) {
      messages.push(
        TextConstants.ReceiversManagement.DeviceErrorTooltipMessages[errCode]
      );
    }
  });

  if (POWER_ERROR_CODES.includes(powerError)) {
    messages.push(
      TextConstants.ReceiversManagement.PowerErrorTooltipMessages[powerError]
    );
  }

  return messages.join('/');
};

export const ReceiverErrorRenderer = (params) => {
  if (!params.value) {
    return '';
  }

  const errCodes = !isNaN(params.data.rer)
    ? params.data.rer.toString().split('').map(Number)
    : [];
  const powerSuplyStatus = parseInt(params.data.prs);
  const message = getTooltipMessage(errCodes, powerSuplyStatus);

  return (
    <CTooltip
      content={<span className="text-danger">{message}</span>}
      placement="top"
    >
      <span className="text-danger">
        {params.value}
        <CIcon name="cil-info" style={{ marginLeft: 6, marginBottom: 14 }} />
      </span>
    </CTooltip>
  );
};

export default ReceiverErrorRenderer;
